export enum TeaserLayout {
  VARIANT_A = 'teaser-variant-a',
  VARIANT_B = 'teaser-variant-b',
  VARIANT_C = 'teaser-variant-c',
  VARIANT_D = 'teaser-variant-d',
  VARIANT_E = 'teaser-variant-e',
  VARIANT_E_WITHOUT_DESCRIPTION = 'teaser-variant-e-without-description',
  VARIANT_A_WITHOUT_IMAGE = 'teaser-variant-a-without-image',
  VARIANT_B_WITHOUT_IMAGE = 'teaser-variant-b-without-image',
  VARIANT_C_WITHOUT_IMAGE = 'teaser-variant-c-without-image',
  VARIANT_D_WITHOUT_IMAGE = 'teaser-variant-d-without-image',
  VARIANT_C_WITHOUT_IMAGE_WITH_DATE = 'teaser-variant-c-without-image-with-date',
  CARD_A = 'teaser--card-a',
  CARD_B = 'teaser--card-b',
  CARD_C = 'teaser--card-c',
  RESULT = 'teaser--result',
  PUBMED = 'teaser--pubmed',
}

export const LayoutKeys = Object.keys(TeaserLayout);
export const LayoutValues = Object.values(TeaserLayout);

export interface RocheTeaserTranslations {
  readMore: string;
}

export enum Target {
  SELF = '_self',
  BLANK = '_blank',
}
